import { useMemo } from 'react';

export function useUserAvatar(user) {
  return useMemo(() => {
    const username = user?.username || '';
    if (!username) return 'U';

    const [apellidos, nombres] = username.split(',');
    const apellido = apellidos?.trim().split(' ')[0] || '';
    const nombre = nombres?.trim().split(' ')[0] || '';

    return `${apellido.charAt(0)}${nombre.charAt(0)}`.toUpperCase();
  }, [user]);
}